<template>
  <span class="cat-tooltip-wrapper" v-tooltip.right-start="tooltip" role="button">
    <i class="fa fa-question-circle"></i>
  </span>
</template>

<script>
import tooltips from '../toolTipsText';

export default {
  name: 'tool-tip',
  props: ['index'],
  data() {
    return {
      tooltip: tooltips.text[this.index],
    };
  },
};
</script>

<style lang="less">
  .tooltip {
    display: block !important;
    padding: 4px;
    z-index: 10000;

    .tooltip-inner {
      background: #555;
      color: white;
      border-radius: 2px;
      padding: 5px 10px 4px;
      text-align: left;
    }
    .tooltip-arrow {
      display: none;
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }
    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }

  }
</style>



// WEBPACK FOOTER //
// ToolTip.vue?2c7937d8